import { FC } from "react";
import bgImage from "../../Assets/homev2/el-bg.png";
import image from "../../Assets/homev2/el-image.png";
import tag from "../../Assets/homev2/el-tag.png";
import info from "../../Assets/homev2/el-info-image.png";
import { OutlineButton } from "./Buttons";
import ContainedButton from "./Buttons/Contained";

const ExpertLobby: FC = () => {
  return (
    <section
      className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden max-h-[911px] relative"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 flex flex-col justify-between gap-4 lg:gap-8 items-center">
        <div>
          <h2 className="text-3xl md:text-5xl lg:text-7xl text-black font-semibold text-center">
            Expert Lobby
          </h2>
          <h4 className="text-center text-black md:text-2xl mt-4">
            Meet a sales growth consultant today.
          </h4>
          <div className="flex  max-w-[180px] items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
            <a
              href="https://calendly.com/salesbox-meet/salesmrkt?month=2023-08"
              className="w-full"
            >
              <ContainedButton theme="primary">
                <span className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-white block rounded-full" />
                  Live Call
                </span>
              </ContainedButton>
            </a>
            <a
              href="https://calendly.com/salesbox-meet/salesmrkt?month=2023-08"
              className="w-full"
            >
              <OutlineButton theme="black">Schedule Call</OutlineButton>
            </a>
          </div>
        </div>
        <div className="w-[50%] lg:w-[45%] relative">
          <img
            src={image}
            alt="Customize my solution"
            width="100%"
            height="100%"
            loading="lazy"
          />
          <img
            src={tag}
            alt="Virtual meeting with a man"
            width="100%"
            height="100%"
            loading="lazy"
            className="absolute bottom-0 -right-[40%]"
          />
          <img
            src={info}
            alt="Info tag"
            width="100%"
            height="100%"
            loading="lazy"
            className="absolute top-[10%] xl:bottom-1/4 -left-2/4 md:-left-1/4 xl:-left-1/2 w-28 md:w-40 lg:w-60 xl:w-80"
          />
        </div>
      </div>
    </section>
  );
};

export default ExpertLobby;
